export interface MultiplierTracePoint {
  t: number;
  m: number;
}

/** Rebuild the exponential path when joining a round already in progress. */
export function buildReloadTrace(
  elapsedSeconds: number,
  currentMultiplier: number,
  samplesPerSecond = 10,
): MultiplierTracePoint[] {
  const elapsed = Number.isFinite(elapsedSeconds) ? Math.max(0, elapsedSeconds) : 0;
  const current = Number.isFinite(currentMultiplier) ? Math.max(1, currentMultiplier) : 1;

  if (elapsed < 0.01) return [{ t: 0, m: 1 }, { t: 0.01, m: current }];

  const sampleCount = Math.min(300, Math.max(2, Math.ceil(elapsed * samplesPerSecond)));
  const points: MultiplierTracePoint[] = [];

  for (let index = 0; index <= sampleCount; index++) {
    const progress = index / sampleCount;
    const t = elapsed * progress;
    const rawMultiplier = Math.pow(current, progress);
    const m = index === sampleCount ? current : Math.floor(rawMultiplier * 100) / 100;
    points.push({ t, m: Math.max(1, m) });
  }

  return points;
}
